import script from "./Prepaid.vue?vue&type=script&setup=true&lang=js"
export * from "./Prepaid.vue?vue&type=script&setup=true&lang=js"

import "./Prepaid.vue?vue&type=style&index=0&id=7326dd18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7326dd18"]])

export default __exports__